<template>
  <div class="footer">
    <div class="wrap">
      <div class="contact">
        <div class="desc">
          <p class="title">上海茵谷科技有限公司</p>
          <p>地址：上海市金山区亭卫公路1500号（山阳经济小区）</p>
          <p>邮箱：contact@eongoo.com</p>
        </div>
      </div>
      <div class="copyright">
        <span>©{{ new Date().getFullYear() }} <span class="brand">EONGOO</span> All rights reserved.</span>
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2024071160号</a>
        <a href="https://creativemarket.com/hindiastudio/706768-Gaoel-Sans" class="brand" title="Gaoel Sans" target="_blank">Gaoel Sans</a> created by Hindia Studio - License by CreativeMarket
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeFooter'
}
</script>

<style lang="scss" scoped>
a{
  &:hover{
    text-decoration: underline;
  }
}

.footer{
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
  z-index: 0;
  background-color: $themeBarColor;
  color: $themeColor;
}
.contact{
  display: flex;
  padding: 80px 0 10px;
  justify-content: space-between;
  align-items: center;
  .desc{
    p{
      padding: 10px 0;
      line-height: 22px;
      font-size: 14px;
      &.title{
        font-size: 18px;
      }
    }
  }
  .code{
    img{
      display: block;
      width: 140px;
      height: 140px;
    }
    p{
      text-align: center;
      line-height: 50px;
      font-size: 18px;
    }
  }
}
.copyright{
  border-top: 1px solid rgba(#fff, .4);
  padding: 25px 0;
  line-height: 20px;
  font-size: 12px;
  .brand{
    font-family: 'gaoel';
    text-transform: uppercase;
  }
}
@media screen and (min-width: 750px){
  .contact{
    .desc{
      position: relative;
      padding-left: 30px;
      &:before{
        position: absolute;
        top: 13px;
        left: 0;
        bottom: 14px;
        width: 2px;
        background-color: rgba(#fff, 1);
        content: '';
      }
    }
  }
}
@media screen and (max-width: 750px){
  .contact{
    flex-direction: column;
    .desc{
      text-align: center;
    }
    .code{
      margin-top: 20px;
    }
  }
  .copyright{
    text-align: center;
  }
}
@media screen and (min-width: 500px){
  .copyright{
    a{
      margin-left: 2em;
    }
  }
}
@media screen and (max-width: 500px){
  .copyright{
    span, a{
      display: block;
    }
  }
}
</style>
